/**
 * Where NextActionsContainer renders its Report event / Delete event modals.
 *
 * In the Farm View (`farmLayout`) the events list lives inside the trailing
 * panel's details box (position: relative; z-index: 0), a stacking context
 * that would keep a modal under Bootstrap's body-level backdrop, so the modals
 * are portalled to document.body. The Field View renders them inline, as it
 * always has.
 */

const shouldPortalEventModals = (farmLayout) => Boolean(farmLayout);

module.exports = { shouldPortalEventModals };
